import { e as entry } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

//
var script = {
  mixins: [entry]
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "js-entry o-entry c-contact-entry" }, [
    _c("h3", { staticClass: "c-contact-entry__name" }, [
      _vm._v("\n        " + _vm._s(_vm.entryData.Json.Name) + "\n    ")
    ]),
    _vm._v(" "),
    _c("dl", { staticClass: "c-contact-entry__details" }, [
      _vm.entryData.Json.Phone
        ? _c("dt", [_vm._v(_vm._s(_vm.$t("global.phone")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Phone
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Phone))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Mobile
        ? _c("dt", [_vm._v(_vm._s(_vm.$t("global.mobile")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Mobile
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Mobile))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Fax ? _c("dt", [_vm._v("Fax")]) : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Fax
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Fax))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Email ? _c("dt", [_vm._v("Email")]) : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Email
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Email))])
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=ContactEntry.js.map
